// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + {"55122":"8915365963d3fa96","61701":"2dda6cb20694754c","61748":"a10d31296777f75f"}[chunkId] + ".css";
};